import {
  isCalculationMethodVisible,
  isLadderCalculationMethodVisible,
} from 'shared/widgets/CommissionsCalculationMethodInput/utils/calculationMethodVisibility';
import * as yup from 'yup';

const requiredWhenVisible = (isVisible: (parent: any) => boolean) =>
  yup
    .string()
    .nullable()
    .test('calculation-method-required', 'Обязательное поле', (value, ctx) =>
      isVisible(ctx.parent) ? !!value : true,
    );

const calculationMethodValidation = requiredWhenVisible((parent) =>
  isCalculationMethodVisible(parent.rate),
);

const ladderCalculationMethodValidation = requiredWhenVisible((parent) =>
  isLadderCalculationMethodVisible(parent.ladder?.steps),
);

const oneOfNot: yup.TestFunction = (_, context) => {
  return (
    !!context.parent.max || !!context.parent.min || !!context.parent.percent || !!context.parent.fix
  );
};

const percentField = yup
  .number()
  .typeError('Введите число')
  .when('zeroed', {
    is: false,
    then: (schema) =>
      schema
        .min(0)
        .max(100)
        .nullable()
        .test('one-of-not', 'Одно из значений должно быть заполнено', oneOfNot),
    otherwise: (schema) => schema.nullable(),
  });

const currencyField = yup
  .number()
  .typeError('Введите число')
  .when('zeroed', {
    is: false,
    then: (schema) =>
      schema
        .min(0)
        .nullable()
        .test('one-of-not', 'Одно из значений должно быть заполнено', oneOfNot),
    otherwise: (schema) => schema.nullable(),
  });

const minCurrencyField = yup
  .number()
  .typeError('Введите число')
  .when('zeroed', {
    is: false,
    then: (schema) =>
      schema
        .min(0)
        .when('max', {
          is: (value: number) => !!value,
          then: (schema) =>
            schema
              .lessThan(
                yup.ref<number>('max'),
                'Значение "MIN" не может быть больше значения "MAX"',
              )
              .notOneOf(
                [yup.ref<number>('max')],
                'Значение "MIN" не может быть равно значению "MAX"',
              ),
        })
        .nullable()
        .test('one-of-not', 'Одно из значений должно быть заполнено', oneOfNot),
    otherwise: (schema) => schema.nullable(),
  });

export const COMMISSIONS_SCHEMA = yup.object().shape({
  rate: yup.object().shape({
    percent: percentField,
    fix: currencyField,
    max: currencyField,
    min: minCurrencyField,
    zeroed: yup.boolean(),
  }),
  merchant: yup.string().required('Обязательное поле'),
  name: yup.string().required('Обязательное поле'),
  provider: yup.string().required('Обязательное поле'),
  transactionTypes: yup.array().of(yup.string()).min(1, 'Обязательное поле').required(),
  currency: yup.string().required('Обязательное поле'),
  originId: yup.number().notRequired(),
  calculationMethod: calculationMethodValidation,
});

const stepSchema = yup.object().shape({
  stepNumber: yup.number().required(),
  thresholdFrom: yup.number().typeError('Введите число').required('Обязательное поле'),
  isLastStep: yup.boolean().notRequired(),
  thresholdTo: yup
    .number()
    .typeError('Введите число')
    .when('isLastStep', {
      is: true,
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.required('Обязательное поле'),
    }),
  commissionRate: yup.object().shape({
    percent: yup.number().typeError('Введите число').required('Обязательное поле'),
    fix: yup.number().typeError('Введите число').nullable(),
    min: yup.number().typeError('Введите число').nullable(),
    max: yup.number().typeError('Введите число').nullable(),
    zeroed: yup.boolean(),
  }),
});

const ladderSchema = yup.object().shape({
  periodType: yup.string().required('Обязательное поле'),
  ladderType: yup.string().required('Обязательное поле'),
  steps: yup.array().of(stepSchema),
});

export const LADDER_COMMISSIONS_SCHEMA = yup.object().shape({
  merchant: yup.string().required('Обязательное поле'),
  name: yup.string().required('Обязательное поле'),
  provider: yup.string().required('Обязательное поле'),
  transactionTypes: yup.array().of(yup.string()).min(1, 'Обязательное поле').required(),
  currency: yup.string().required('Обязательное поле'),
  originId: yup.number().notRequired(),
  ladder: ladderSchema,
  calculationMethod: ladderCalculationMethodValidation,
});
